import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, TemplateRef, Input } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LogoutConfirmationDialogComponent } from 'src/app/common/logout-confirmation-dialog/logout-confirmation-dialog.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { HelperListService } from 'src/app/core/services/helperlist.service';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { Location } from '@angular/common';
import { localStorageConstants, localStorageVariables } from 'src/app/core/localStorageConstants/localStorageConstants';
import { UserProfileService } from 'src/app/core/services/user-profile.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { EnvService } from 'src/app/core/services/env.service';
import { TranslateService } from '@ngx-translate/core';
import { RolePermissionService } from 'src/app/core/services/role-permission.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { LoginService } from 'src/app/core/services/login.service';
import { CallBackTransformService } from 'src/app/core/services/call-back-transform.service';
import { DashboardService } from 'src/app/core/services/dashboard.service';
import { PeopleListService } from 'src/app/core/services/peopleList.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { CustomizationService } from 'src/app/core/services/customization.service';
import { QuestionnaireInteractionService } from 'src/app/core/services/questionnaire-interaction.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  modalRef: BsModalRef;
  @ViewChild(LogoutConfirmationDialogComponent)
  confirmDialog: LogoutConfirmationDialogComponent;
  changePasswordDialog: ChangePasswordComponent;
  @ViewChild('logoutoption') logoutoption: ElementRef;
  @ViewChild('toggleProfileClick') toggleProfileClick: ElementRef;
  public show = true;
  public notificationPermission: boolean;
  changePassword: boolean;
  public error: boolean;
  public message: any;
  public user: any;
  public username: any;
  public userTitle: any;
  public userFlag = false;
  public searchInput = null;
  public conformMessage = 'Are you sure you want to log out?';
  public imageURL;
  public agencyName;
  public language: any;//= 'en';
  public agencyLanguageId = localStorage.getItem('agencyLanguageId');

  assessmentConfig: any;
  languages: any;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
  boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
  regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
  whiteColor=this.brandingDetails?.branding?.BackgroundColors?.ReportTabBg;
  cornColor=this.brandingDetails?.branding?.BackgroundColors?.StyledName;
  profileDrop=this.brandingDetails?.branding?.BackgroundColors?.ProfileDropdown;
  profileShadow=this.brandingDetails?.branding?.BackgroundColors?.ProfileBoxShadow;
  toastErrorBgColor: any;
  toastSuccessBgColor: any;
  toastSuccessFontColor: any;
  toastErrorFontColor: any;
  headerColor: string;
  notification1: any;
  notification2: any;
  dashboardBorder: any;
  cancelButtonHover: any;
  cancelButton: any;
  button1: any;
  button2: any;
  buttonHover: any;
  buttonFont: any;
  alternateRowsLight: any;
  alternateRowsDark: any;
  headerBackground: any;
  tableHeadColor: any;
  disabledHeaderBackground: any;
  disableCategoryColor:any;
  editButtonBackground: any;
  editButtonHoverBackground: any;
  activateBtn: any;
  buttonFontColor: any;
  EditBtn: any;
  EditBtnHover: any;
  redBtn: any;
  blueBtn: any;
  greenBtn: any;
  confirmDeleteBtn: any;
  confirmDeleteBtnHover: any;
  confirmCancelBtn: any;
  gridBorderColor: any;
  favIconLogo: any;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  dropdownBackgroundcolor: any;
  selectPersonStatus: any;
  matTealDark:any;
  matError:any;
  matWhite:any;
  matOrange:any;
  matGreenYellow:any;
  matGreyGreen:any;
  matLightGreen:any;
  matBlack:any;
  matRussianBlack:any;
  matInputGrey:any;
  matCheckBoxBg:any;
  checkedCheckBoxBg:any;
  matTealLight:any;
  calenderNotSelectedBg:any;
  datePickerContent:any;
  checkBoxDisabledBg:any;
  breadcrumbBg:any;
  tableFontColor:any;
  headerFontColor: any;
  greyLightBg:any;
  tabBody:any;
  cardFontColor:any;
  linkButtons:any;
  dropdownBorderColor:any;
  btnLightBlue: any;
  questionnaireSubHeader: any;
  activeTabColor: any;
  disabledQuestionnaireHeader: any;
  subTabBgColor: any;
  cardCancelButton: any;
  activeAdminTabFontColor: any;
  searchList = [];
  totalSearchCount: number;
  languageSetSubscribe: any;
  brandingSetSubscribe: any;
  isChanged: boolean=false;
  changedLang: any;

  @Input() set confirmCastValue(data) {
      if (data && data?.value) {
        if(data.triggerFrom=='languageChange'){
          this.updateLanguage(this.changedLang);
        }
        else if(data.triggerFrom=='logout'){
          this.confirmDialog.openModal()
        }
      }else{
        if(data.triggerFrom=='languageChange'){
          this.language = localStorage.getItem('lang') || 'en';       }
      }
    }

  constructor(
    private assessmentService: AssessmentService,
    private modalService: BsModalService,
    public cookieService: CookieService,
    private helperListService: HelperListService,
    private router: Router,
    private renderer: Renderer2,
    private interactorService: InteractorService,
    private localStorageService: LocalStorageService,
    private location: Location,
    private lookupService: LookupService,
    private userProfileService: UserProfileService,
    private commonService: CommonService,
    private oauthService: OAuthService,
    private envService: EnvService,
    private translatorService: TranslateService,
    private rolePermissionService: RolePermissionService,
    private loginService: LoginService,
    private callBackTransformService: CallBackTransformService,
    private dashboardService: DashboardService,
    private peopleListService: PeopleListService,
    private languageService : LanguageService,
    private customizationService : CustomizationService,
    public qiService: QuestionnaireInteractionService,
  ) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!event.url.includes('/search-list/') && this.searchInput != null) {
          this.searchInput = null;
        }
      }
    });
    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        this.logoutoption &&
        !this.logoutoption.nativeElement.contains(e.target) &&
        this.toggleProfileClick &&
        !this.toggleProfileClick.nativeElement.contains(e.target)
      ) {
        this.show = true;
      }
    });
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = JSON.parse(localStorage.getItem('branding'));
        this.updateTheme(this.brandingDetails)
      }
    });

  }


  ngOnInit(): void {
    this.commonService.setProfilePic('');
    this.getUserDetails();
    // tslint:disable-next-line: deprecation
    this.interactorService?.helperUserCast?.subscribe(data => {
      if(data){
        this.getUserDetails();
      }
    });

    // tslint:disable-next-line: deprecation
    this.interactorService?.helperUserRefreshCast?.subscribe(value => {
      if(value){
        this.getUserDetails();
      }
    });
    this.qiService.valueChangesCast.subscribe((val) => {
      this.isChanged = val;
    });
    // tslint:disable-next-line: deprecation
    this.commonService.profilePic.subscribe(profilePic => {
      this.imageURL = profilePic;
    });
    this.setProfile();
    this.agencyName = this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyName);
    if (sessionStorage.getItem('firstLogin') != 'true') {
      this.lookupService.getLanguages().subscribe(
        (res) => {
          if (res.StatusCode !== 200) {
            this.error = true;
            this.message = res.Message;
          } else {
            this.languages = res.Data.agencyLanguage;
            this.agencyLanguageId = localStorage.getItem('agencyLanguageId');
            let currentLanguage = this.languages?.find((x) => x.agencyLanguageID == this.agencyLanguageId);
            this.language = currentLanguage?.attribute;
            sessionStorage.removeItem('firstLogin');
          }
        },
        (err) => {
          this.error = true;
          this.message = err.Message;
        }
      );
    } else {
      this.languageSetSubscribe = this.languageService?.languageValueCast?.subscribe((val: any) => {
        if (val) {
          this.languages = val;
          this.agencyLanguageId = localStorage.getItem('agencyLanguageId');
          let currentLanguage = this.languages?.find((x) => x.agencyLanguageID == this.agencyLanguageId);
          this.language = currentLanguage?.attribute;
        }
      })
    }
    this.brandingSetSubscribe = this.customizationService?.brandingValueCast?.subscribe((val: any) => {
      if (val) {
        this.brandingDetails = val;
        this.interactorService.changeBrandingDetails(this.brandingDetails);
        this.updateTheme(val);
      }
    })
  }
  updateTheme(data:any){
    this.semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
          this.regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
          this.boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
          this.whiteColor=this.brandingDetails?.branding?.BackgroundColors?.ReportTabBg;
          this.cornColor=this.brandingDetails?.branding?.BackgroundColors?.StyledName;
          this.profileDrop=this.brandingDetails?.branding?.BackgroundColors?.ProfileDropdown;
          this.profileShadow=this.brandingDetails?.branding?.BackgroundColors?.ProfileBoxShadow;
          this.headerColor = this.brandingDetails?.branding.BackgroundColors.Headers;
          document.documentElement.style.setProperty('--headerColor', this.headerColor);
          document.documentElement.style.setProperty('--semiBoldFont', this.semiBoldFont);
          document.documentElement.style.setProperty('--boldFont', this.boldFont);
          document.documentElement.style.setProperty('--regularFont', this.regularFont);
          document.documentElement.style.setProperty('--whiteColor', this.whiteColor);
          document.documentElement.style.setProperty('--cornColor', this.cornColor);
          document.documentElement.style.setProperty('--profileDrop', this.profileDrop);
          document.documentElement.style.setProperty('--profileShadow', this.profileShadow);
          this.setBackgroundColors();
          this.setFontColors();
          this.setMatColors();
          this.favIcon.href = this.brandingDetails?.branding?.LogoMark;
          this.dropdownBackgroundcolor = this.brandingDetails?.branding?.BackgroundColors?.AlternateRows;
  }
  setBackgroundColors() {
    this.toastErrorBgColor = this.brandingDetails?.branding?.AlertColors?.ErrorAlertColor;
    this.toastSuccessBgColor = this.brandingDetails?.branding?.AlertColors?.SuccessAlertColor;
    this.notification1 = this.brandingDetails?.branding.BackgroundColors?.Notification1;
    this.notification2 = this.brandingDetails?.branding.BackgroundColors?.Notification2;
    this.cancelButton = this.brandingDetails?.branding.BackgroundColors?.CancelBtnAddPerson;
    this.cancelButtonHover = this.brandingDetails?.branding.BackgroundColors?.CancelBtnAddPersonHover;
    this.dashboardBorder = this.brandingDetails?.branding.BackgroundColors?.DashboardNotificationBorder;
    this.button2 = this.brandingDetails?.branding.BackgroundColors?.Button2;
    this.buttonHover = this.brandingDetails?.branding.BackgroundColors?.ButtonHover;
    this.buttonFontColor = this.brandingDetails?.branding.BackgroundColors?.BtnFont;
    this.activateBtn = this.brandingDetails?.branding.BackgroundColors?.ActivateBtn;
    this.EditBtn = this.brandingDetails?.branding.BackgroundColors?.EditBtn;
    this.EditBtnHover = this.brandingDetails?.branding.BackgroundColors?.EditBtnHover;
    this.redBtn = this.brandingDetails?.branding.BackgroundColors?.BtnRed;
    this.blueBtn = this.brandingDetails?.branding.BackgroundColors?.BtnBlue;
    this.greenBtn = this.brandingDetails?.branding.BackgroundColors?.BtnGreen;
    this.confirmDeleteBtnHover = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtnHover;
    this.confirmDeleteBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtn;
    this.confirmCancelBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmCancelBtn;
    this.alternateRowsLight = this.brandingDetails?.branding?.BackgroundColors?.AlternateRowsLight;
    this.alternateRowsDark = this.brandingDetails?.branding?.BackgroundColors?.AlternateRowsDark;
    this.headerBackground = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.selectPersonStatus = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.disabledHeaderBackground = this.brandingDetails?.branding?.BackgroundColors?.DisabledHeaderBackground;
    this.disableCategoryColor = this.brandingDetails?.branding?.BackgroundColors?.disableCategoryColor;
    this.editButtonBackground = this.brandingDetails?.branding?.BackgroundColors?.EditBtn;
    this.editButtonHoverBackground = this.brandingDetails?.branding?.BackgroundColors?.EditBtnHover;
    this.gridBorderColor = this.brandingDetails?.branding?.BackgroundColors?.GridBorder;
    this.greyLightBg = this.brandingDetails?.branding?.BackgroundColors?.SideBarBackground;
    this.tabBody = this.brandingDetails?.branding?.BackgroundColors?.TabBody;
    this.cardFontColor = this.brandingDetails?.branding?.BackgroundColors?.CardFontColor;
    this.dropdownBorderColor = this.brandingDetails?.branding?.BackgroundColors?.DropdownBorder;
    this.btnLightBlue = this.brandingDetails?.branding?.BackgroundColors?.ResendColor;
    this.questionnaireSubHeader = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireSubHeader;
    this.whiteColor=this.brandingDetails?.branding?.BackgroundColors?.ReportTabBg;
    this.disabledQuestionnaireHeader = this.brandingDetails?.branding?.BackgroundColors?.DisabledQuestionnaireHeader;
    this.subTabBgColor = this.brandingDetails?.branding.BackgroundColors?.CardBg;
    this.cardCancelButton = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardCancelButton;
    this.activeAdminTabFontColor = this.brandingDetails?.branding?.BackgroundColors?.ActiveAdminTabFontColor;

    if (this.toastErrorBgColor) {
      document.documentElement.style.setProperty('--toastErrorBgColor', this.toastErrorBgColor);
    }
    if (this.toastSuccessBgColor) {
      document.documentElement.style.setProperty('--toastSuccessBgColor', this.toastSuccessBgColor);
    }
    if (this.notification1) {
      document.documentElement.style.setProperty('--notification1', this.notification1);
    }
    if (this.notification2) {
      document.documentElement.style.setProperty('--notification2', this.notification2);
    }
    if (this.dashboardBorder) {
      document.documentElement.style.setProperty('--dashboardBorder', this.dashboardBorder);
    }
    if (this.cancelButton) {
      document.documentElement.style.setProperty('--cancelButton', this.cancelButton);
    }
    if (this.cancelButtonHover) {
      document.documentElement.style.setProperty('--cancelButtonHover', this.cancelButtonHover);
    }
    if (this.button2) {
      document.documentElement.style.setProperty('--button2', this.button2);
    }
    if (this.buttonHover) {
      document.documentElement.style.setProperty('--buttonHover', this.buttonHover);
    }
    if (this.activateBtn) {
      document.documentElement.style.setProperty('--activateBtn', this.activateBtn);
    }
    if (this.buttonFontColor) {
      document.documentElement.style.setProperty('--buttonFontColor', this.buttonFontColor);
    }
    if (this.EditBtn) {
      document.documentElement.style.setProperty('--EditBtn', this.EditBtn);
    }
    if (this.EditBtnHover) {
      document.documentElement.style.setProperty('--EditBtnHover', this.EditBtnHover);
    }
    if (this.alternateRowsLight) {
      document.documentElement.style.setProperty('--alternateRowsLight', this.alternateRowsLight);
    }
    if (this.alternateRowsDark) {
      document.documentElement.style.setProperty('--alternateRowsDark', this.alternateRowsDark);
    }
    if (this.headerBackground) {
      document.documentElement.style.setProperty('--headerBackground', this.headerBackground);
    }
    if (this.selectPersonStatus) {
      document.documentElement.style.setProperty('--selectPersonStatus', this.headerBackground);
    }
    if (this.disabledHeaderBackground) {
      document.documentElement.style.setProperty('--disabledHeaderBackground', this.disabledHeaderBackground);
    }
    if (this.disableCategoryColor) {
      document.documentElement.style.setProperty('--disableCategoryColor', this.disableCategoryColor);
    }
    if (this.editButtonBackground) {
      document.documentElement.style.setProperty('--editButtonBackground', this.editButtonBackground);
    }
    if (this.editButtonHoverBackground) {
      document.documentElement.style.setProperty('--editButtonHoverBackground', this.editButtonHoverBackground);
    }
    if (this.confirmDeleteBtnHover) {
      document.documentElement.style.setProperty('--confirmDeleteBtnHover', this.confirmDeleteBtnHover);
    }
    if (this.confirmDeleteBtn) {
      document.documentElement.style.setProperty('--confirmDeleteBtn', this.confirmDeleteBtn);
    }
    if (this.confirmCancelBtn) {
      document.documentElement.style.setProperty('--confirmCancelBtn', this.confirmCancelBtn);
    }
    if (this.gridBorderColor) {
      document.documentElement.style.setProperty('--gridBorderColor', this.gridBorderColor);
    }
    if (this.redBtn) {
      document.documentElement.style.setProperty('--redBtn', this.redBtn);
    }
    if (this.blueBtn) {
      document.documentElement.style.setProperty('--blueBtn', this.blueBtn);
    }
    if (this.greenBtn) {
      document.documentElement.style.setProperty('--greenBtn', this.greenBtn);
    }
    if (this.greyLightBg) {
      document.documentElement.style.setProperty('--greyLightBg', this.greyLightBg);
    }
    if (this.tabBody) {
      document.documentElement.style.setProperty('--tabBody', this.tabBody);
    }
    if (this.cardFontColor) {
      document.documentElement.style.setProperty('--cardFontColor', this.cardFontColor);
    }
    if (this.dropdownBorderColor) {
      document.documentElement.style.setProperty('--dropdownBorderColor', this.dropdownBorderColor);
    }
    if (this.btnLightBlue) {
      document.documentElement.style.setProperty('--btnLightBlue', this.btnLightBlue);
    }
    if (this.questionnaireSubHeader) {
      document.documentElement.style.setProperty('--questionnaireSubHeader', this.questionnaireSubHeader);
    }
    if (this.whiteColor) {
      document.documentElement.style.setProperty('--whiteColor', this.whiteColor);
    }
    if (this.disabledQuestionnaireHeader) {
      document?.documentElement?.style?.setProperty('--disabledQuestionnaireHeader', this.disabledQuestionnaireHeader);
    }
    if (this.subTabBgColor) {
      document?.documentElement?.style?.setProperty('--subTabBgColor', this.subTabBgColor);
    }
    if (this.cardCancelButton) {
      document?.documentElement?.style?.setProperty('--cardCancelButton', this.cardCancelButton);
    }
    if (this.activeAdminTabFontColor) {
      document.documentElement.style.setProperty('--activeAdminTabFontColor', this.activeAdminTabFontColor);
    }
  }

  setMatColors(){
    this.matTealDark = this.brandingDetails?.branding?.MatColors?.MatTealDark;
    this.matBlack = this.brandingDetails?.branding?.MatColors?.MatBlack;
    this.matWhite = this.brandingDetails?.branding?.MatColors?.MatWhite;
    this.matOrange = this.brandingDetails?.branding?.MatColors?.MatOrange;
    this.matGreenYellow = this.brandingDetails?.branding?.MatColors?.MatGreenYellow;
    this.matGreyGreen = this.brandingDetails?.branding?.MatColors?.MatGreyGreen;
    this.matLightGreen = this.brandingDetails?.branding?.MatColors?.MatLightGreen;
    this.matRussianBlack = this.brandingDetails?.branding?.MatColors?.MatRussianBlack;
    this.matInputGrey = this.brandingDetails?.branding?.MatColors?.MatInputGrey;
    this.matCheckBoxBg = this.brandingDetails?.branding?.MatColors?.MatCheckBoxBg;
    this.checkedCheckBoxBg = this.brandingDetails?.branding?.MatColors?.CheckedCheckBoxBg;
    this.matTealLight = this.brandingDetails?.branding?.MatColors?.MatTealLight;
    this.calenderNotSelectedBg = this.brandingDetails?.branding?.MatColors?.CalenderNotSelectedBg;
    this.datePickerContent = this.brandingDetails?.branding?.MatColors?.DatePickerContent;
    this.checkBoxDisabledBg = this.brandingDetails?.branding?.MatColors?.CheckBoxDisabledBg;
    this.matError = this.brandingDetails?.branding.BackgroundColors?.ErrorFontColor;

    if (this.matTealDark) {
      document.documentElement.style.setProperty('--matTealDark', this.matTealDark);
    }
    if (this.matWhite) {
      document.documentElement.style.setProperty('--matWhite', this.matWhite);
    }
    if (this.matOrange) {
      document.documentElement.style.setProperty('--matOrange', this.matOrange);
    }
    if (this.matGreenYellow) {
      document.documentElement.style.setProperty('--matGreenYellow', this.matGreenYellow);
    }
    if (this.matGreyGreen) {
      document.documentElement.style.setProperty('--matGreyGreen', this.matGreyGreen);
    }
    if (this.matLightGreen) {
      document.documentElement.style.setProperty('--matLightGreen', this.matLightGreen);
    }
    if (this.matRussianBlack) {
      document.documentElement.style.setProperty('--matRussianBlack', this.matRussianBlack);
    }
    if (this.matInputGrey) {
      document.documentElement.style.setProperty('--matInputGrey', this.matInputGrey);
    }
    if (this.matCheckBoxBg) {
      document.documentElement.style.setProperty('--matCheckBoxBg', this.matCheckBoxBg);
    }
    if (this.checkedCheckBoxBg) {
      document.documentElement.style.setProperty('--checkedCheckBoxBg', this.checkedCheckBoxBg);
    }
    if (this.matTealLight) {
      document.documentElement.style.setProperty('--matTealLight', this.matTealLight);
    }
    if (this.calenderNotSelectedBg) {
      document.documentElement.style.setProperty('--calenderNotSelectedBg', this.calenderNotSelectedBg);
    }
    if (this.datePickerContent) {
      document.documentElement.style.setProperty('--datePickerContent', this.datePickerContent);
    }
    if (this.checkBoxDisabledBg) {
      document.documentElement.style.setProperty('--matError', this.checkBoxDisabledBg);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
    if (this.matBlack) {
      document.documentElement.style.setProperty('--matBlack', this.matBlack);
    }
   }

   setFontColors(){
    this.toastErrorFontColor = this.brandingDetails?.branding?.AlertColors?.ErrorAlertFontColor;
    this.toastSuccessFontColor = this.brandingDetails?.branding?.AlertColors?.SuccessAlertFontColor;
    this.buttonFont = this.brandingDetails?.branding.BackgroundColors?.BtnFont;
    this.tableHeadColor = this.brandingDetails?.branding?.BackgroundColors?.TableHeadColor;
    this.headerFontColor = this.brandingDetails?.branding?.BackgroundColors?.HeaderFontColor;
    this.tableFontColor = this.brandingDetails?.branding?.BackgroundColors?.TableFontColor;
    this.breadcrumbBg = this.brandingDetails?.branding?.BackgroundColors?.SidebarHoverBackground;
    this.linkButtons = this.brandingDetails?.branding.BackgroundColors?.LinkButtons;
    this.activeTabColor = this.brandingDetails?.branding?.BackgroundColors?.BlackHeaderFont;
     if (this.toastErrorFontColor) {
       document.documentElement.style.setProperty('--toastErrorFontColor', this.toastErrorFontColor);
     }
     if (this.toastSuccessFontColor) {
       document.documentElement.style.setProperty('--toastSuccessFontColor', this.toastSuccessFontColor);
     }
     if (this.buttonFont) {
       document.documentElement.style.setProperty('--buttonFont', this.buttonFont);
     }
     if (this.tableHeadColor) {
       document.documentElement.style.setProperty('--tableHeadColor', this.tableHeadColor);
     }
     if (this.headerFontColor) {
      document.documentElement.style.setProperty('--headerFontColor', this.headerFontColor);
    }
    if (this.tableFontColor) {
      document.documentElement.style.setProperty('--tableFontColor', this.tableFontColor);
    }
    if (this.breadcrumbBg) {
      document.documentElement.style.setProperty('--breadcrumbBg', this.breadcrumbBg);
    }
    if (this.linkButtons) {
      document.documentElement.style.setProperty('--linkButtons', this.linkButtons);
    }
    if (this.activeTabColor) {
      document.documentElement.style.setProperty('--activeTabColor', this.activeTabColor);
    }
   }

  getAgencyName() {
    if (this.rolePermissionService?.isAuthorized('Switch Agency', 'View')) {
      this.agencyName = this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyName);
    } else {
      // Use userProfileService.agencyName if available, otherwise fallback to localStorage
      this.agencyName = this.userProfileService.agencyName ||
                        this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyName);
    }
    this.notificationPermission = this.rolePermissionService.isAuthorized('Header_Notificationbell', 'View');
    return this.agencyName;
  }

  getUserName() {
    let userName = '';
    if (this.rolePermissionService?.isAuthorized('Switch Agency', 'View')) {
      userName = this.username;
      this.localStorageService.saveInLocalStorage(localStorageVariables.username, userName);
    } else {
      userName = this.userProfileService.helperName;
      this.localStorageService.deleteLocalStorageByKey(localStorageVariables.username);
      this.localStorageService.saveInLocalStorage(localStorageVariables.username, userName);
    }
    return userName;
  }

  getUserTitle() {
    if (this.rolePermissionService?.isAuthorized('Switch Agency', 'View')) {
      this.userTitle = this.localStorageService.getDataFromLocalStorage(localStorageVariables.role);
    } else {
      this.userTitle = this.userProfileService.userTitle;
    }
    return this.userTitle;
  }

  changeLanguage(value) {
    this.changedLang=value;
    if (!this.isChanged) {
     this.updateLanguage(value);
    }else{
      const obj = {
        confirm: true,
        route: null,
        triggerFrom: 'languageChange'
      };
      this.qiService.setConfirmation(obj);
    }
  }
  updateLanguage(value){
    if (value) {
      this.language = value;
    }
    let currentLanguage = this.languages.find((x) => x.attribute == this.language);
    localStorage.setItem('lang', this.language);
    localStorage.setItem('agencyLanguageId', currentLanguage.agencyLanguageID);
    this.translatorService.use(this.language);
    this.languageService.updateLanguageState(this.language);
  }

  toggleProfile() {
    this.show = !this.show;
  }

  logout() {
    localStorage.setItem('sessionTime', (new Date().getTime()).toString());
    localStorage.setItem('isBrowserClosed', 'false');
    sessionStorage.removeItem('token_hint');
    this.cookieService.deleteAll('');
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll('/', window.location.hostname);
    this.cookieService.deleteAll('/', 'https://' + window.location.hostname);
    this.localStorageService.deleteAllLocalStorage();
    this.oauthService.logOut(false);
    this.oauthService.revokeTokenAndLogout();
    console.log('this.envService.logoutUrl logout 192: ', this.envService.logoutUrl);

    window.location.href = this.envService.logoutUrl;
  }

  conformLogout(value) {
    if (value) {
      this.logout();
      // this.userProfileService.logOut().subscribe(
      //   (response :any) => {
      //     if (response.StatusCode === 200) {
      //       this.logout();
      //     } else {
      //       this.logout();
      //     }
      //   },
      //   (error) => {
      //   }
      // );

    } else {
      // User clicked "No" on logout - restore the change state
      const obj = {
        confirm: false,
        route: null,
        triggerFrom: 'logoutCancel'
      };
      this.qiService.setConfirmation(obj);
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered',
    });
  }

  changepasswordModal() {
    this.changePassword = true;
    const modal = document.getElementById('modal-pwd');
    modal.style.opacity = '1';
  }
  hide() {
    this.changePassword = false;
    const modalDialog = document.getElementById('dialog');
    modalDialog.style.animation = 'fadeIn .25s ease-in both';
  }

  /**
    * get user details
    */
  getUserDetails() {
    this.helperListService
      .getUserDetails()
      // tslint:disable-next-line: deprecation
      ?.subscribe(
        (res) => {
          if (res?.StatusCode !== 200) {
            this.error = true;
            this.message = res?.Message;
          } else {
            this.user = res?.Data?.userDetails;
            this.username = res?.Data?.userDetails?.name;
            this.userTitle = res?.Data?.userDetails?.title;
            this.localStorageService.saveInLocalStorage(localStorageVariables.username, this.username);
            if (this.user?.helperID === 0) {
              this.userFlag = true;
            }
          }
        },
        (err) => {
          this.error = true;
          this.message = err?.Message;
        }
      );
  }

  setProfile() {
    // tslint:disable-next-line: deprecation
    this.userProfileService.getProfile().subscribe(
      (response) => {
        if (response.StatusCode === 200) {
          if (response.Data.userProfile) {
            if (response.Data.userProfile.imageByteArray) {
              this.commonService.setProfilePic('data:image/png;base64,' + response.Data.userProfile.imageByteArray);
            }
            // Update agency name after profile is loaded
            if (!this.rolePermissionService?.isAuthorized('Switch Agency', 'View')) {
              this.agencyName = this.userProfileService.agencyName;
            }
          }
        }
      });
    setTimeout(() => {
      this.translatorService.setDefaultLang('en');
      this.translatorService.use(localStorage.getItem('lang') || 'en');
      this.language = localStorage.getItem('lang') || 'en';
    }, 3000);
  }

  search() {
    const fromRoute = this.location.path();
    if (!fromRoute.includes('/search-list/')) {
      this.localStorageService.saveInLocalStorage(localStorageConstants.goToPreviousRoute, fromRoute);
    }
    if (this.searchInput != null && this.searchInput.replace(/\s/g, '').length > 0) {
      const searchText = this.searchInput.trim();
      this.dashboardService.currentPageNo.subscribe((pageNo) => {
        this.dashboardService.currentPageSize.subscribe((pageSize) => {
          const searchObj = {
            searchKey: searchText,
            pageNo: pageNo,
            pageSize: pageSize
          };
          this.dashboardService.getUpperPaneSearchList(searchObj).subscribe(
            (response) => {
              if (response.StatusCode === 200) {
                if (response.Data?.responseStatusCode === 1010) {
                  this.searchList = response.Data?.upperpaneSearchList;
                  if (this.searchList.length !== 0) {
                    this.totalSearchCount = this.searchList[0]?.totalCount;
                  } else {
                    this.totalSearchCount = 0;
                  }
                }
                if (this.totalSearchCount == 1 && this.searchList[0]?.type == "Person") {
                  if (this.searchList[0]?.isSharedPerson) {
                    this.peopleListService
                      .getPersonSharingDetails(this.searchList[0]?.index)
                      .subscribe((output) => {
                        if (output && output?.StatusCode === 200) {
                          let queryParams :any = {
                            personIndex: this.searchList[0]?.index,
                            agencySharingIndex: output?.Data?.agencySharingIndex,
                            collaborationSharingIndex:
                              output?.Data?.collaborationSharingIndex,
                            isActiveForSharing:
                              output?.Data?.isActiveForSharing,
                            isFromSearch: true,
                            tab:'Profile'
                          };
                          const queryParamsString = new URLSearchParams(queryParams).toString();
                          window.location.href = `/people/details/activesharing?${queryParamsString}`;
                          // this.router.navigate(['/people/details/activesharing'], {
                          //   queryParams: queryParams,
                          // });
                        }
                      });
                  } else {
                    let queryParams:any = { personIndex: this.searchList[0]?.index, isFromSearch: true, tab:'Profile' };
                    // this.router.navigate(['/people/details'], {
                    //   queryParams: queryParams,
                    // });
                    const queryParamsString = new URLSearchParams(queryParams).toString();
                    window.location.href = `/people/details?${queryParamsString}`;
                  }
                } else {
                  this.router.navigate(['/search-list', searchText]);
                }
              }
            }
          );
        });
      });
    }
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }
  /**
   * Get Support label from en.json translation file
   */
  getSupportLabel(): string {
    const currentLang = this.translatorService.currentLang;
    this.translatorService.use('en');
    const supportLabel = this.translatorService.instant('Support');
    this.translatorService.use(currentLang);
    return supportLabel;
  }

logoutEvent(){
  if (!this.isChanged) {
    this.confirmDialog.openModal()
  }else{
    const obj = {
      confirm: true,
      route: null,
      triggerFrom: 'logout'
    };
    this.qiService.setConfirmation(obj);
  }
}
  ngOnDestroy() {
    if(this.languageSetSubscribe){
      this.languageSetSubscribe?.unsubscribe()
    }
    if(this.brandingSetSubscribe){
      this.brandingSetSubscribe?.unsubscribe()
    }
  }
}
